import React, { Component, PropTypes } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { Field, reduxForm } from 'redux-form';

const fields = [ 
  'hstnumber','hstprovince'
];
fields['contact'] = ['phone', 'address', 'city', 'province','postal_code', 'country' ];

const EditorProfileForm = props => {
  //console.log("props before const");
  //console.log(props.initialValues);
  const { fields: { contact: {phone, address, city, province, postal_code,country}, hstnumber, hstprovince } , handleSubmit, pristine, load, reset, submitting } = props;
  //console.log(fields);
  //console.log("rendering editor form with pros");
  //console.log(props);
  {/*  TODO - find out why fields value is not being used */ }
  return (    
    (props.initialValues.contact) ?
    <div>
      <div className="profile-form-container">
        <form onSubmit={handleSubmit}>
          <label>Phone: </label>
          <Field className="form-field" label="Phone:" name="contact.phone" placeholder="phone number" component="input" type="text" value={props.initialValues.contact.phone}/><br/><br/>
          <label>HST Number: </label>
          <Field className="form-field" name="hstnumber" placeholder="HST Number" component="input" type="text" value={props.initialValues.hstnumber}/><br/><br/>
          <label>HST Province: </label>
          <Field className="form-field" name="hstprovince" placeholder="HST Province" component="input" type="text" value={props.initialValues.hstprovince}/><br/><br/>
          <label>Address: </label>
          <Field className="form-field" name="contact.street" placeholder="Address" component="input" type="text" value={props.initialValues.contact.street} /><br /><br />
          <label>City: </label>
          <Field className="form-field" name="contact.city" placeholder="City" component="input" type="text" value={props.initialValues.contact.city} /><br /><br />
          <label>Province: </label>
          <Field className="form-field" name="contact.province" placeholder="Province" component="input" type="text" value={props.initialValues.contact.province} /><br /><br />
          <label>Postal Code: </label>
          <Field className="form-field" name="contact.postal_code" placeholder="Postal Code" component="input" type="text"  value={props.initialValues.contact.postal_code} /><br /><br />
          <label>Country: </label>
          <Field className="form-field" name="contact.country" placeholder="Country" component="input" type="text" value={props.initialValues.contact.country} /><br /><br />
          <br/><br/>
          <button type="submit" className="register-button"> Update </button>
          </form>
      </div>
    </div>
    :
    <div>Loading...</div>
  )
}

EditorProfileForm.propTypes = {
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  load: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default reduxForm({
  form: 'profile-form-container',
  fields,
  enableReinitialize: true
})(EditorProfileForm);



// WEBPACK FOOTER //
// ./src/components/dashboards/EditorProfileForm.js